import styled from 'styled-components';
import { font, media } from 'style';
import { Heading } from 'components';

export default {
  Content: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  Headings: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
    text-align: center;
  `,
  Heading: styled(Heading)`
    max-width: 610px;
  `,
  SubHeading: styled.div`
    max-width: 780px;
    margin-top: 10px;
    font-size: ${font.size.large};
  `,
  BulletsContainer: styled.div<{ labeled: boolean }>`
    max-width: 900px;

    ${({ labeled }) =>
      !labeled &&
      media.md`
      padding-left: 40px;
    `}
  `,
  Footer: styled.div`
    margin-top: 50px;
    text-align: center;
    line-height: 25px;
  `,
};
